import { Services } from '@sigma-frontend-libs/commons'
import { EVENTSHISTORY_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, labelModes } from '@/utils'

import selectorOwner from '@/components/selector/owner'

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.eventsHistory}-filter`
    },
    [
      h(
        components['text-field'],
        {
          props: {
            value: this.proxy.entityId,
            label: this.getTranslate(`${Services.eventsHistory}.labels.entityId`),
            clearable: true,
            labelMode: labelModes.hidden,
            dense: true,
            details: false
          },
          on: {
            input: event => {
              this.proxy.entityId = event
            }
          }
        }
      ),
      h(
        selectorOwner,
        {
          props: {
            value: this.proxy.userId,
            labelMode: labelModes.hidden,
            dense: true
          },
          on: {
            input: event => {
              this.proxy.userId = event
            }
          }
        }
      ),
      h(
        components.select,
        {
          props: {
            value: this.proxy.service,
            label: this.getTranslate(`${Services.eventsHistory}.labels.service`),
            items: this.selectItems,
            clearable: true,
            labelMode: labelModes.hidden,
            dense: true,
            details: false
          },
          on: {
            input: event => {
              this.proxy.service = event
            }
          }
        }
      ),
      h(
        components.select,
        {
          props: {
            value: this.proxy.type,
            label: this.getTranslate(`${Services.eventsHistory}.labels.type`),
            items: EVENTSHISTORY_TYPES.map(type => {
              return {
                title: this.getTranslate(`${Services.eventsHistory}.types.${type}`),
                value: type
              }
            }),
            clearable: true,
            labelMode: labelModes.hidden,
            dense: true,
            details: false
          },
          on: {
            input: event => {
              this.proxy.type = event
            }
          }
        }
      )
    ]
  )
}
